<template>
    <VJoySelect v-model="selectedCurrency" label="Currency" @update:model-value="handleCurrencyUpdate">
        <option v-for="currency in sortedCurrencies" :key="`currency--${currency.code}`" :value="currency.code">
            {{ currency.label }}
        </option>
    </VJoySelect>
</template>
<script setup lang="ts">
    import {CurrencyCode} from '@navbar-api';
    import {computed, ref, useTranslation} from '#imports';
    import {VJoySelect} from '@maltjoy/core-vue';
    const {t} = useTranslation();

    type Currency = {
        code: CurrencyCode;
        label: string;
    };

    const props = defineProps<{
        selectedCurrency: string;
    }>();

    const emit = defineEmits<{
        (e: 'update:currency', currencyCode: CurrencyCode): void;
    }>();

    const availableCurrencyCodes = ref<CurrencyCode[]>(Object.values(CurrencyCode));
    const selectedCurrency = ref<string>(props.selectedCurrency);

    const sortedCurrencies = computed(() => {
        return availableCurrencyCodes.value
            .map((availableCurrencyCode): Currency => {
                return {
                    code: availableCurrencyCode,
                    label: t('general.currency.label', {currencyCode: availableCurrencyCode}),
                };
            })
            .sort((a: Currency, b: Currency) => a.label.localeCompare(b.label));
    });

    function handleCurrencyUpdate(currencyCode: string) {
        emit('update:currency', currencyCode as CurrencyCode);
    }
</script>
